import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid2,
  Typography,
} from "@mui/material";
import { StyledErrorMessage } from "../style/modalStyle";
import React, { useState, useEffect } from "react";
import CommonRadioButton from "../common-components/CommonRadioButton";
import CorpData from "./Corp";
import { calculateTaxFilingTotal } from "../../utils/StorageUtils";
import CommonTaxModal from "../common-components/CommonTaxModal";

const LLCData = ({
  formik,
  options,
  is_tax_free,
}: {
  formik: any;
  options: any;
  is_tax_free: boolean;
}) => {
  const isEmptyFiling = options.name.includes("Empty Filing");

  const [totalMembersData, setTotalMembersData] = useState<any>(null);
  const [totalMembersITINData, setTotalMembersITINData] = useState<any>(null);

  const totalBase = calculateTaxFilingTotal(
    formik,
    formik.values.has_itin,
    isEmptyFiling
  );
  const total =
    totalBase +
    (totalMembersData?.price || 0) +
    (totalMembersITINData?.price || 0);

  useEffect(() => {
    setTotalMembersData(null);
    setTotalMembersITINData(null);
  }, [formik?.values?.tax_filing]);

  // Update formik total_amount when total changes
  useEffect(() => {
    formik.setFieldValue("total_amount", total);
  }, [total]);

  const handleITINChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue("has_itin", e.target.checked);
  };

  const handleConsentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue("consent", e.target.checked);
  };

  const handleTotalMembersChange = (data: any) => {
    setTotalMembersData(data);
  };

  const handleTotalMembersITINChange = (data: any) => {
    setTotalMembersITINData(data);
  };

  return (
    <Box>
      <Grid2 container spacing={1}>
        <Grid2
          size={{ xs: 12, md: 12 }}
          sx={{
            marginBottom: "10px",
          }}
        >
          {" "}
          <Typography
            variant="h4"
            sx={{
              whiteSpace: "nowrap",
              fontSize: "18px",
              fontWeight: 600,
              color: "#060110",
            }}
          >
            Do you have an ITIN?
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                onChange={handleITINChange}
                checked={formik.values.has_itin}
              />
            }
            label="I don't have an ITIN, I need one +$100.00"
          />
          <StyledErrorMessage>
            {formik?.errors.has_itin &&
              (formik?.touched.has_itin || formik?.submitCount > 0) &&
              formik?.errors.has_itin}
          </StyledErrorMessage>
        </Grid2>

        {options.name.includes("LLC") && (
          <Grid2 size={{ xs: 12, md: 4 }}>
            <CommonRadioButton
              label="Does your company have multimembers?*"
              names="multi_members"
              formik={formik}
              trueLabel="Yes"
              falseLabel="No"
              isGap
              // disabled={!isEditing}
            />
          </Grid2>
        )}

        <Grid2 size={{ xs: 10, md: 12 }}>
          {formik.values.multi_members === true &&
            options.name.includes("LLC") && (
              <CorpData
                formik={formik}
                showTotal={false}
                onTotalMembersChange={handleTotalMembersChange}
                onTotalMembersITINChange={handleTotalMembersITINChange}
              />
            )}
        </Grid2>

        {/* <Grid2
          size={{ xs: 12, md: 12 }}
          sx={
            {
              // marginBottom: "10px"
            }
          }
        >
          {" "}
          <Typography
            variant="h4"
            sx={{
              whiteSpace: "nowrap",
              fontSize: "18px",
              fontWeight: 600,
              color: "#060110",
            }}
          >
            Consent <span style={{ color: "#ff0000" }}>*</span>
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                onChange={handleConsentChange}
                checked={formik.values.consent}
              />
            }
            label={
              <>
                I agree to the{" "}
                <span
                  style={{
                    color: "#2977CC",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation(); // 🧠 Prevent checkbox toggle
                    window.open(
                      "https://theitin.com/privacy-policy/",
                      "_blank"
                    );
                  }}
                >
                  privacy policy
                </span>
                .
              </>
            }
          />
          <StyledErrorMessage>
            {formik?.errors.consent &&
              (formik?.touched.consent || formik?.submitCount > 0) &&
              formik?.errors.consent}
          </StyledErrorMessage>
        </Grid2> */}

        <Typography
          variant="h4"
          sx={{
            whiteSpace: "nowrap",
            fontSize: "18px",
            fontWeight: 600,
            color: "#060110",
            marginTop: "20px",
          }}
        >
          Total{" "}
          <span
            style={{
              color: is_tax_free ? "#999" : "#2977CC",
              fontWeight: 600,
              fontSize: "20px",
              paddingLeft: 4,
              textDecoration: is_tax_free ? "line-through" : "none",
            }}
          >
            ${total.toFixed(2)}
          </span>
          {is_tax_free && (
            <span
              style={{
                color: "#2977CC",
                fontWeight: 600,
                fontSize: "20px",
                paddingLeft: 8,
              }}
            >
              $0
            </span>
          )}
        </Typography>
      </Grid2>
    </Box>
  );
};

export default LLCData;
